import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './locales/fr.json';
import ar from './locales/ar.json';

const STORAGE_KEY = 'dz_lang';

const detectLang = () => {
  // Priority: URL ?lang= > localStorage > default 'fr'
  try {
    if (typeof window !== 'undefined') {
      const q = new URLSearchParams(window.location.search).get('lang');
      if (q === 'fr' || q === 'ar') {
        localStorage.setItem(STORAGE_KEY, q);
        return q;
      }
    }
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'fr' || saved === 'ar') return saved;
  } catch { /* noop */ }
  return 'fr';
};

i18n.use(initReactI18next).init({
  resources: {
    fr: { translation: fr },
    ar: { translation: ar },
  },
  lng: detectLang(),
  fallbackLng: 'fr',
  interpolation: { escapeValue: false },
  returnEmptyString: false,
});

// Apply <html dir/lang> on init and on language change
const applyDir = (lng) => {
  if (typeof document === 'undefined') return;
  const isRtl = lng === 'ar';
  document.documentElement.setAttribute('lang', lng);
  document.documentElement.setAttribute('dir', isRtl ? 'rtl' : 'ltr');
  document.body.classList.toggle('rtl', isRtl);
};
applyDir(i18n.language);
i18n.on('languageChanged', (lng) => {
  try { localStorage.setItem(STORAGE_KEY, lng); } catch { /* noop */ }
  applyDir(lng);
});

export default i18n;
